import _ from 'lodash';
import createModel, { prop } from 'models/lib/create_model';

export default function (modelDef) {
  const typeName = _.snakeCase(modelDef.modelName).toUpperCase();

  return createModel({
    overrideToJs(toJs) {
      return () => ({ ...toJs(), name: typeName });
    },
    // Whether this location emits report analytics events (e.g. 'Report Timezone Changed').
    // Defaults to false; report-like locations override to true.
    tracksReportEvents() {
      return false;
    },
    ...modelDef,
    statics: {
      create(attrs) {
        return new this(attrs);
      },
      typeName,
      ...modelDef.statics,
    },
  });
}

export { prop };
